import React from 'react';
import { Col, Row } from 'reactstrap';
import downArrowImg from './down-arrow.svg';

const Question = ({questionObj, questionOnClickHandler, selectedOption}) => {

    const onClickHandler = (type) => {
        questionOnClickHandler(type);
    }

    const selData = selectedOption.find(obj=> obj.name === questionObj.name);

    return (
        <div className='select-div mb-5'>
            <Row>
                <Col xs="1"><div className='circle mt-1'>{questionObj.id}</div></Col>
                <Col xs="11" className='question-title ps-3'>{questionObj.title}</Col>
            </Row>
            <div className='custom-select' onClick={() => onClickHandler(questionObj.name)}>
                {selData ? <span className='custome-select-span'>{selData.option.join(', ')}</span> : <span className='question-placeholder'>Select one</span>}
                <img src={downArrowImg} className="float-end question-down-arrow" alt='' />
            </div>
        </div>
    );
};

export default Question;